import {createStyles, makeStyles} from '@material-ui/core';
import {
  DRAGGABLE_ITEM_BOX_SHADOW,
  FONT_PRIMARY_COLOR
} from 'src/style/variable';

export const useStyles = makeStyles(() =>
  createStyles({
    ccmFloatCardHeader: {
      alignItems: 'center',
      gap: '2rem',
      '& .MuiCardHeader-action': {
        margin: 0
      },
      cursor: 'move'
    },
    ccmFloatCard: {
      position: 'absolute',
      bottom: 20,
      left: 20,
      zIndex: 1250,
      boxShadow: DRAGGABLE_ITEM_BOX_SHADOW,
      lineHeight: '1em',
      maxWidth: 400,
      width: '100%',
      maxHeight: '90vh',
      overflow: 'auto'
    },
    ccmFloatCardHeaderWrapper: {
      display: 'flex',
      gap: '0.5rem',
      alignItems: 'center',
      paddingBlock: '0.5rem',
      fontWeight: 'bold',
      fontSize: '1.5rem',
      letterSpacing: '0.03em'
    },
    ccmFloatCardMainHeaderWrapper: {
      display: 'flex',
      justifyContent:'space-between',
      borderBottom: '1px solid #eeeeee',
    },
    ccmCancelTimer:{
      display:'flex',
      alignItems:'center'
    },
    ccmPanelDragIcon: {
      cursor: 'move'
    },
    ccmTimerWrapper: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: '3rem'
    },
    ccmPanelInfoWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem'
    },
    link: {
      padding: 0,
      fontWeight: 'normal'
    },
    ccmPatientInfoWrapper: {
      paddingTop: 0,
      color: '#54585b',
      display: 'grid',
      gap: '0.75rem',
      marginTop: '0.5rem',
      gridTemplateColumns: 'max-content min-content 1fr'
    },
    ccmButtonWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '0.5rem'
    },
    ccmPatientDetailsHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontWeight: 'bold',
      lineHeight: 1
    },
    recordDetailsButton: {
      flex: 1
    },
    editPlansButton: {
      flex: 1
    },
    createPlanButton: {
      flex: 1
    },
    notesLabel: {
      marginBottom: '0.5rem'
    },
    notesInputWrapper: {
      margin: 0,
      padding: 0
    },
    cardContent: {
      paddingTop: 0
    },
    textArea: {
      height: 'auto',
      paddingBottom: 0,
      marginBottom: 0,
      '& .MuiInputBase-root': {
        paddingBlock: '1rem',
        paddingInline: '0.75rem',
        height: 50,
        color: FONT_PRIMARY_COLOR
      },
      opacity: 1
    },
    ccmPatientInfoCardContent: {
      paddingBlock: 0
    },
    prevFollowUpNotesWrapper: {
      marginTop: '1.5rem'
    },
    prevFollowUpNote: {
      marginTop: '0.5rem',
      color: '#54585b',
      lineHeight: 1,
      alignItems: 'flex-start',
      '& .MuiFormControlLabel-label': {
        paddingBlock: 9
      }
    },
    markFollowUpNoteAsDoneWrapper: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.3rem',
      paddingTop: 0
    },
    followUpNotesAndMarkAsDoneWrapper: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      justifyContent: 'space-between',
      marginTop: '0.5rem'
    }
  })
);
